import { gql } from '@apollo/client';

export const REMOVE_LAB_ANALYSIS_INSTANCE_FROM_PROPERTY = gql`
mutation removeLabAnalysisInstanceFromProperty($input: RemoveLabAnalysisInstanceFromPropertyInput!) {
  removeLabAnalysisInstanceFromProperty(input: $input) {
    __typename
    clientMutationId
    errors
    labAnalysisInstanceUuid
  }
}
`
